import React, { useState, useEffect } from 'react';
import { white,  FlexBoxRow, } from '../styles/globalstyles'
import { ButtonGrey, ButtonOrangeNoLink, ButtonGreyNoLink} from './buttons'
import {motion, AnimatePresence } from 'framer-motion';
import facepaint from 'facepaint';
const breakpoints = [576, 820, 992, 1200]

const mq = facepaint(
    breakpoints.map(bp => `@media (min-width: ${bp}px)`)
  )
const cookiebanner = {
    initial: {bottom: "-10vh", opacity: 0},
    animate: {bottom: "4vh", opacity: 1},
    exit: {bottom: "-10vh", opacity: 0}

}

const ConsentCookie = () => {
    const [cookieState, setCookieState] = useState("open")

    useEffect(() =>{
        let cname="accept"
        window.dataLayer = window.dataLayer || [];
        let cookie;
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
            c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
             cookie =  c.substring(name.length, c.length)
             if (cookie == "true"){
                 setCookieState("true")
                window.dataLayer.push({
                    'event': "consent_given",
                    'consent': "true",
                    });
            
            }
            else if (cookie == "false") {
                setCookieState("false")
                window.dataLayer.push({
                    'event': "consent_given",
                    'consent': "false",
                    });
                }
            else {setCookieState("open")}
            }
        }
 
        
        }
    )

    const accept = (cvalue) => {
        var cname ="accept"
        var d = new Date();
        var exdays= 90
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        if (cvalue == "true") {
            window.dataLayer.push({
                'event': "consent_given",
                'consent': "true",
                });
        }
        else if (cvalue == "false") {
            window.dataLayer.push({
                'event': "consent_given",
                'consent': "false",
                });
        }
        setCookieState(cvalue)

    }
    return (
        <>
        <AnimatePresence> 
            {(cookieState == "open") &&
            <motion.div initial="initial" animate="animate" exit="exit" variants={cookiebanner} css={{position: "fixed", width: "86vw", height: "auto%", left: "9%",  background: white, zIndex: 7, padding: "1em 2em", boxShadow: "-5px 0px 12px 2px #949494", borderRadius: "1em"}}>
               <FlexBoxRow > 
                <p css={{marginBottom: "0 !important " }, [mq({maxWidth: ["100%", "100%", "50%", "50%"], marginBottom: [0,0,0,0], fontSize: ["0.7em","0.7em","0.8em","0.8em"]})]}>Diese Webseite nutzt Tracking-Technologien von Drittanbietern, um ihre Dienste anzubieten und stetig zu verbessern. Ich bin damit einverstanden und kann meine Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen oder ändern.</p>
                <ButtonOrangeNoLink onClick={() => accept("true")} text="Ich stimme zu" css={{fontSize: "0.8em !important", margin: "0 0.4em", padding: "0.8em 1.8em"}} >Ich stimme zu</ButtonOrangeNoLink>
                <ButtonGreyNoLink onClick={() => accept("false")} text="Ich lehne ab" css={{fontSize: "0.8em !important", margin: "0 0.4em", padding: "0.8em 1.8em"}}>Ich lehne ab</ButtonGreyNoLink>
                <ButtonGrey link="datenschutzerklaerung" text="Datenschutzerklärung" css={{fontSize: "0.8em !important", margin: "0 0.4em", padding: "0.8em 1.8em"}}>Datenschutzerklärung</ButtonGrey>
                </FlexBoxRow>
            </motion.div>
            }
        </AnimatePresence>
        </>
    )
}

export default ConsentCookie;
